import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const faqItems = [
  { q: 'faq_q1', a: 'faq_a1' },
  { q: 'faq_q2', a: 'faq_a2' },
  { q: 'faq_q3', a: 'faq_a3' },
  { q: 'faq_q4', a: 'faq_a4' },
  { q: 'faq_q5', a: 'faq_a5' },
];

export default function FAQ() {
  const { t } = useTranslation('reparation');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section ref={ref} id="faq" className="bg-soft-gray py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-10">
        <h2
          className={`font-manrope font-bold text-slate-primary text-2xl md:text-3xl lg:text-4xl text-center mb-12 md:mb-16 transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {t('faq_h2')}
        </h2>

        <div className="space-y-3">
          {faqItems.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className={`bg-white rounded-lg border border-soft-dark overflow-hidden transition-all duration-700 ${
                  isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
                }`}
                style={{ transitionDelay: `${idx * 80 + 200}ms` }}
              >
                <button
                  onClick={() => setOpenIndex(isOpen ? null : idx)}
                  className="w-full flex items-center justify-between p-4 md:p-5 text-left"
                >
                  <span className="font-manrope font-semibold text-slate-primary text-sm md:text-base pr-4">
                    {t(item.q)}
                  </span>
                  <span
                    className={`w-8 h-8 flex-shrink-0 flex items-center justify-center rounded-full bg-soft-gray transition-transform duration-300 ${
                      isOpen ? 'rotate-180' : ''
                    }`}
                  >
                    <i className="ri-arrow-down-s-line text-slate-primary" />
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-500 ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-4 md:px-5 pb-4 md:pb-5 text-slate-primary/70 text-sm leading-relaxed">
                    {t(item.a)}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}